module.exports = __webpack_public_path__ + "fonts/Bariol_Regular.4191138.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Bariol_Regular.otf
// module id = ./src/assets/fonts/Bariol_Regular.otf
// module chunks = 34